import { ExternalLink, BookOpen, TrendingUp, Gavel } from "lucide-react";
import { useTranslation } from "react-i18next";

// Industrial reference (Hoechsmann WTP) + price benchmark / auction widgets.
export default function ResourceWidgets({ query = "" }) {
  const { t } = useTranslation();
  const q = encodeURIComponent(query || "");
  const wtp = "https://wtp.hoechsmann.com/en/lexikon";
  const machineseeker = q ? `https://www.machineseeker.com/search?query=${q}` : "https://www.machineseeker.com/";
  const troostwijk = "https://www.troostwijkauctions.com/ro";

  return (
    <div className="space-y-4" data-testid="resource-widgets">
      <div className="border border-slate-200 bg-white p-5">
        <div className="flex items-center gap-2 mb-1.5">
          <BookOpen className="w-4 h-4 text-orange-600" />
          <h3 className="font-bold text-slate-900 text-sm uppercase tracking-wide">{t("resources.techTitle")}</h3>
        </div>
        <p className="text-sm text-slate-500 mb-3">{t("resources.techDesc")}</p>
        <a href={wtp} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-sm font-bold text-orange-600 hover:gap-3 transition-all" data-testid="resource-wtp">
          {t("resources.techCta")} <ExternalLink className="w-3.5 h-3.5" />
        </a>
      </div>

      <div className="border border-slate-200 bg-white p-5">
        <div className="flex items-center gap-2 mb-1.5">
          <TrendingUp className="w-4 h-4 text-orange-600" />
          <h3 className="font-bold text-slate-900 text-sm uppercase tracking-wide">{t("resources.priceTitle")}</h3>
        </div>
        <p className="text-sm text-slate-500 mb-3">{t("resources.priceDesc")}</p>
        <div className="flex flex-col gap-2">
          <a href={machineseeker} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-sm font-semibold text-slate-700 hover:text-orange-600 transition-colors" data-testid="resource-machineseeker">
            <TrendingUp className="w-3.5 h-3.5" /> {t("resources.machineseeker")} <ExternalLink className="w-3 h-3" />
          </a>
          <a href={troostwijk} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-sm font-semibold text-slate-700 hover:text-orange-600 transition-colors" data-testid="resource-troostwijk">
            <Gavel className="w-3.5 h-3.5" /> {t("resources.troostwijk")} <ExternalLink className="w-3 h-3" />
          </a>
        </div>
      </div>
    </div>
  );
}
